import { render, staticRenderFns } from "./DocumentCommentHistory.vue?vue&type=template&id=450d31cc"
import script from "./DocumentCommentHistory.vue?vue&type=script&lang=js"
export * from "./DocumentCommentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports